<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	export default {
		name: 'App',
		mounted() {
			// 移除固定尺寸缩放逻辑，改为监听窗口变化触发重绘
			window.addEventListener('resize', this.handleResize)
			// 初始化时触发一次3D场景重绘（如果有3D）
			this.handleResize()
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.handleResize)
		},
		methods: {
			handleResize() {
				// 通知子组件（model.vue）更新3D场景尺寸
				window.dispatchEvent(new CustomEvent('window-resize'))
			}
		}
	}
</script>

<style>
	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}

	html,
	body,
	#app {
		width: 100vw;
		height: 100vh;
		overflow: hidden;
	}

	/* 工具类保留，优化flex兼容性 */
	.flex-center {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-wrap: wrap;
	}

	.flex-start {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap;
	}

	.flex-end {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		flex-wrap: wrap;
	}

	.flex-colum {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.flex-colum-start {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: flex-start;
	}

	.flex-colum-end {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: flex-end;
	}

	.flex-between {
		display: flex;
		justify-content: space-between;
		align-items: center;
		flex-wrap: wrap;
	}

	.flex-around {
		display: flex;
		justify-content: space-around;
		align-items: center;
		flex-wrap: wrap;
	}

	.text-ellipsis {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.el-message {
		height: 40px;
	}

	.el-message__icon {
		font-size: 30px;
	}

	.el-textarea__inner {
		background: #091724 !important;
		border: 1px solid #4578A8 !important;
		color: #B3C8DC !important;
	}

	/* 全局滚动条样式 - 统一主题色 */
	::-webkit-scrollbar {
		width: 8px;
		height: 8px;
	}

	::-webkit-scrollbar-track {
		background: rgba(9, 23, 36, 0.5);
		border-radius: 4px;
	}

	::-webkit-scrollbar-thumb {
		background: linear-gradient(180deg, #4578A8 0%, #36d1ff 100%);
		border-radius: 4px;
		transition: all 0.3s ease;
	}

	::-webkit-scrollbar-thumb:hover {
		background: linear-gradient(180deg, #36d1ff 0%, #4578A8 100%);
		box-shadow: 0 0 6px rgba(54, 209, 255, 0.5);
	}

	::-webkit-scrollbar-corner {
		background: rgba(9, 23, 36, 0.5);
	}

	/* Firefox 滚动条样式 */
	* {
		scrollbar-width: thin;
		scrollbar-color: #4578A8 rgba(9, 23, 36, 0.5);
	}
</style>